import type { LabelHTMLAttributes } from 'react';

import { twm } from '../../../core/themes/tw-merge';

type Props = LabelHTMLAttributes<HTMLLabelElement>;

export const Label = ({ children, className, ...rest }: Props) => {
  return (
    <label
      {...rest}
      className={twm(
        'font-regular font-inter text-body-sm leading-lh-body-sm tracking-normal text-text-secondary',
        className,
      )}
    >
      {children}
    </label>
  );
};
